<template>
    <div class="pronunciationHeaderBlock" v-if="listLength(norskOrdbank.lemma_uttale) > 0">
        <div
            class="pronunciationHeaderColumn"
            v-for="(uttale_items, uttale_lemma_id, key) in (norskOrdbank.lemma_uttale || {})"
            :key="key"
        >
            <span
                v-for="(uttale_item, lemmaId, sub_key) in (uttale_items || '')"
                :key="sub_key"
                :data-lemma="lemmaId"
            >
                <span>
                    <span
                        class="grunnform"
                        :data-lemma="lemmaId"
                        :id="getBlockSpeakerId(uttale_lemma_id, lemmaId, 'pronunciationSpeakText')"
                        v-html="highlightMatchedtext(uttale_item.name)"
                    />
                    <SpeakTextContent type="span" />
                </span>
                <span class="pronunciation" v-for="(pron_item, pron_key) in (uttale_item.list || [])" :key="pron_key" v-if="pron_item.value">
                    <span v-if="pron_key > 0" class="separator">, </span><Pronunciation :value="pron_item.value" />
                </span>
            </span>
        </div>
    </div>
    <div class="pronunciationHeaderBlock" v-else-if="isLexinBoying()">
        <div
            class="pronunciationHeaderColumn"
        >
            <span
                v-for="(pron_item, key) in (norskOrdbank.lemma_rows || [])"
            >
                <span>
                    <span
                        class="grunnform"
                        :id="getBlockSpeakerId(key, 0, 'pronunciationSpeakText')"
                        v-html="highlightMatchedtext(pron_item.lemma || '')"
                    />
                    <SpeakTextContent type="span" />
                </span>
                <span class="pronunciation" v-for="(pron_sub_item, pron_key) in (pron_item.pronunciation_list || [])" v-if="pron_sub_item.value">
                    <span v-if="pron_key > 0" class="separator">, </span><Pronunciation :value="pron_sub_item.value" />
                </span>
            </span>
        </div>
    </div>
    <div class="pronunciationHeaderBlock" v-else>
        <span class="has-no-pronunciation" v-html="lemValue" />
    </div>
</template>

<script>
import SpeakTextContent from "./SpeakTextContent.vue";
import LexinBoyingResult from "./LexinBoyingResult.vue";
import Pronunciation from "./Pronunciation.vue";

export default {
	name: 'NorskOrdbankResultPronunciation',
    components: {
        SpeakTextContent,
        LexinBoyingResult,
        Pronunciation
    },
    data(){
        return {
            lang_mer: "mer"
        }
    },
	props:{
        'norskOrdbank': {
            required: false,
            default: () => ({})
        },
        'searchWord': {
            required: false,
            default: ""
        },
        'lemValue': {
            required: false,
            default: ""
        }
	},
	mounted(){
        if (this.norskOrdbank.language_code == 'nno') {
            this.lang_mer = "meir";
        }
	},
	methods:{
        isLexinBoying() {
            let value = false;
            if ((this.norskOrdbank.ordklasse || '') == "lexin") {
                value = true;
            }

            return value;
        },
        getBlockSpeakerId(uttale_lemma_id, lemmaId, groupText) {
            let id = this.getBlockId("ordbank-speaker-id");
            id += "-" + uttale_lemma_id.toString() + "-" + lemmaId.toString() + "-" + groupText;

            return id;
        },
        getBlockId(name) {
            return name;
        },
        highlightMatchedtext(text) {
            this.searchWord = this.searchWord.replace("|", "~");
            if (this.searchWord) {
                // Escape regex special characters
                const escaped = this.searchWord.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

                // Allow optional ~ after each character (except space)
                const pattern = [...escaped]
                    .map(char =>
                        char !== " " ? `${char}(?:~*)?` : char
                    )
                    .join("");

                // Prevent matching inside HTML tags
                const regex = new RegExp(
                    pattern + "(?![^<>]*>)",
                    "gi"
                );

                return text.replace(regex, "<span class=\"highlight\">$&</span>");
            }
            return text;
        },
        addClass(letter) {
            if (letter == 'y') {
                return 'underline_position';
            } else {
                return '';
            }
        },
        listLength(list) {
            let value = 0;

            if (typeof list == "object" && Object.keys(list).length > 0) {
                value = Object.keys(list).length;
            }

            return value;
        }
    },
    computed: {
    }
}
</script>
